// @ts-nocheck
/* eslint-enable */
// App
import React, { useEffect, useRef } from 'react';

// Components
import Button from 'app/shared/modules/MobileSRP/__BaseComponents__/Button';
import FilterButtonDropdown from 'app/shared/modules/MobileSRP/__BaseComponents__/FilterButtonDropdown';
import AsyncBedBathComboFilter from 'app/shared/modules/MobileSRP/Header/FilterModules/BedBathComboFilter';

// Hooks
import { useBedButtonLabel } from 'app/shared/modules/MobileSRP/Header/FilterBar/BedBathFilterButton/hooks';

const BedBathFilterButton = ({ ariaButtonLabel, ariaDropdownLabel, onButtonClick, onModalClose, showDropdown }) => {
  // All filter buttons should have this ref to return focus after user has closed the filter modal
  const focusRef = useRef(null);
  const isLoaded = useRef(null);

  // Hook
  const [getButtonLabel, getButtonStatus] = useBedButtonLabel({});
  const buttonLabel = getButtonLabel();
  const isFilterActive = getButtonStatus(buttonLabel);

  useEffect(() => {
    /**
     * isLoaded is a component instance variable. Do not set focus on the button until
     * after the component has been interacted with.
     * @see: https://reactjs.org/docs/hooks-faq.html#is-there-something-like-instance-variables
     */
    if (!isLoaded.current) {
      isLoaded.current = true;
    } else {
      if (!showDropdown) {
        focusRef.current.focus();
      }
    }
  }, [showDropdown]);

  return (
    <>
      <Button
        ariaLabel={ariaButtonLabel}
        ariaExpanded={showDropdown}
        active={isFilterActive}
        onClick={onButtonClick}
        ref={focusRef}
        showCarat
      >
        {buttonLabel}
      </Button>
      {showDropdown && (
        <FilterButtonDropdown
          ariaLabel={ariaDropdownLabel}
          dropdownId={'bed-bath-filter-dropdown'}
          onClose={onModalClose}
        >
          <AsyncBedBathComboFilter showResetButton triggerLocation="search_results" triggerObject="filter_panel" />
        </FilterButtonDropdown>
      )}
    </>
  );
};

export default BedBathFilterButton;
